<template>
    <transition name="fade" mode="out-in">
		<div class="d-flex flex-row my-5">
			<checkbox v-model="selected" :color="disabled" labelSlot :disabled="disabled">
				<div class="flex-grow-1 p-2">
					<fixed-lines :useHeight="false" :lines="2" class="flex-grow-1 d-flex align-items-center">
						<product-link
							class="info-txt pr-3 product-tip-ellipsis secondary-link"
							:product="product"
						>
							{{ product.name }}
						</product-link>
					</fixed-lines>
					<product-price :row="true" :product="product" :priceOverride="isBundle ? null : product.regularPrice.price"/>
				</div>
			</checkbox>
		</div>
    </transition>
</template>

<script>
import { convertToCdnUrl } from 'utils';

export default {
	name: 'product-tip-product',
	props: {
		product: {
			type: Object,
			required: true,
		},
		disabled: {
			type: Boolean,
			default: false,
		},
		isBundle: {
			type: Boolean,
			default: null,
		},
	},
	data () {
		return {
			selected: true,
		};
	},
	computed: {
		src () {
			return convertToCdnUrl('/images/product/' + this.product.id + '?trim&h=80');
		},
		path () {
			return this.$router.route({
				name: 'product',
				params: {
					id: this.product.id,
					name: this.product.name,
				},
			});
		},
	},
	watch: {
		selected (checked) {
			this.selected = checked;
			this.$emit('update-checkbox', {
				product: this.product,
				checked: checked,
			});
		},
	},
};
</script>
